export default "__VITE_ASSET__fd3756b5__"